export const mealPlanPageData = [
  {
    heading: "Meal Planner",
    description: {
      plaintext:
        "Plan meals by selecting the date, then choose breakfast, lunch, or dinner.",
    },
    youMayAlsoLikeTitle: "You May Also Like",
    noMealsAdded: "You currently don’t have any meals added.",
    daysOfWeek: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    mealCategories: ["Breakfast", "Lunch", "Snack", "Dinner", "Other"],
    shareMealPlan: "Share meal plan by email",
    copyMealPlan: "Copy meal plan to clipboard",
    print: "Print",
    share: "Share",
    deleteRecipes: "Delete Recipes",
    deleteRecipe: "Delete Recipe",
    addToShoppingList: "Add to Shopping List",
    addMeal: "Add Meal",
    recipeFromOurCollectionAltText: "A recipe from our collection",
    deliciousRecipeAltText: "a delicious recipe",
    logInToAddMealsLabel: "Log in to add meals",
  },
];

export const mealPlanPopupData = [
  {
    printMealPlanHeading: "Print Meal Plan",
    dateRange: "Date Range",
    shareMealPlanHeading: "Share Meal Plan",
    emailLabel: "Email",
    emailPlaceholder: "john.doe@mail.com",
    note: "This email won’t be used for promotions or other communications.",
    copyMealPlanHeading: "Copy Meal Plan",
    singularMessage: "Are you sure to delete this recipe from your meal plan?",
    pluralMessage: "Are you sure to delete these recipes from your meal plan?",
    youArePlanningText: "You are Planning",
    myRecipeListsHeading: "My Recipe Lists",
    chooseRecipeListDescription:
      "Choose a recipe list to add a recipe to your meal plan.",
    saveYourMealPlanHeading: "Save Your Meal Plan!",
    saveYourMealPlanDescription: {
      html: "\u003Cp\u003ELog in now to:\u003C/p\u003E\n\u003Cul\u003E\n\u003Cli\u003ESave recipes to Meal Plan.\u003C/li\u003E\n\u003Cli\u003ECreate and organize new Meal Plan.\u003C/li\u003E\n\u003Cli\u003EAdd recipes to your permanent Meal Plan.\u003C/li\u003E\n\u003C/ul\u003E\n",
    },
    personalNoteHeading: "Save Your Personal Note!",
    personalNoteDescription: {
      html: "\u003Cp\u003ELog in now to:\u003C/p\u003E\n\u003Cul\u003E\n\u003Cli\u003ESave personal notes.\u003C/li\u003E\n\u003Cli\u003ECreate and organize your recipe.\u003C/li\u003E\n\u003Cli\u003EAdd a personal note for your recipe.\u003C/li\u003E\n\u003C/ul\u003E\n",
    },
    cancelButton: "Cancel",
    printButton: "Print",
    loadingButton: "Loading…",
    sendButton: "Send",
    sendingButton: "Sending…",
    copyButton: "Copy",
    copyingButton: "Copying…",
    yesSureButton: "Yes, I m sure",
    saveButton: "Save",
    savingButton: "Saving…",
    browseRecipesButton: "Browse Recipes",
    addFromMyRecipeLists: "Add From My Recipe Lists",
    backToListButton: "Back to List",
    saveChangesButton: "Save Changes",
    viewRecipeButton: "View Recipe",
    loginRegisterButton: "Login / Register",
    closeModalAriaLabel: "Close modal",
    goToHomepageAriaLabel: "Go to Homepage",
    deleteAriaLabel: "Delete",
    goToRecipeDetailPage: "Go to recipe detail page",
    deleteRecipeAriaLabel: "Delete recipe",
    addRecipeAriaLabel: "Add recipe",
    searchRecipesListLabel: "Search Recipes List",
    closeSearchBarLabel: "Close search bar",
    recipeFromOurCollectionAltText: "A recipe from our collection",
    deliciousRecipeAltText: "a delicious recipe",
    searchPlaceholder: "Search",
    logoBlack: "/logo/logo-black.svg",
    limitExceededTitle: "Limit Exceeded!",
  },
];

export const recipeDetailData = [
  {
    personalNote: "Personal Note",
    enterNotesPlaceholder: "Enter notes..",
    editButton: "Edit",
    deleteButton: "Delete",
    createANoteText: "Create a note",
    viewMealPlan: "View Meal Plan",
    addToMealPlan: "Add to Meal Plan",
    savingText: "Saving...",
    deletePersonalNote: "Are you sure you want to delete this note?",
    cancel: "Cancel",
    sureMessage: "Yes, I m sure",
  },
];
